module.exports = "<button class=\"btn btn-default {{addClass}}\" [disabled]=\"isDisabled\">\n    <i class=\"fi fi-send\"></i>{{ btnText }}\n</button>"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/buttons/send-btn/send-btn.html
// module id = ./web/modern/components/buttons/send-btn/send-btn.html
// module chunks = 0